import React, { useState } from "react";
import { Box, Modal, CircularProgress } from "@mui/material";
import { LazyLoadImage } from "react-lazy-load-image-component";
import HeicPreview from "./HeicPreview";

const imagestyle = {
  position: "fixed",
  inset: 0,
  width: "100vw",
  height: "100vh",
  bgcolor: "#ffffff",
  boxShadow: 24,
  p: 3,
  overflow: "hidden",
};

const Commonmodal = ({ open, onClose, url }) => {
  const [pdfLoading, setPdfLoading] = useState(true);
  const [zoom, setZoom] = useState(1);
  const handleZoomIn = () => setZoom((prev) => Math.min(prev + 0.2, 3)); // max 3x
  const handleZoomOut = () => setZoom((prev) => Math.max(prev - 0.2, 0.5)); // min 0.5x

  const isPdf = url?.match(/\.pdf$/i);
  return (
    <Modal open={open} onClose={onClose} keepMounted>
      <Box sx={imagestyle}>
        <div className="flex justify-between items-center mb-3">
          <a href={url} target="_blank" rel="noopener noreferrer" download>
            <button className="flex gap-2 px-6 py-3 bg-black bg-opacity-80 text-white rounded-3xl hover:bg-opacity-70 transition font-semibold shadow-md">
              ⬇ Download
            </button>
          </a>

          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex justify-center gap-4 z-[9999]">
            <button
              onClick={handleZoomIn}
              className="px-4 py-2 bg-black text-white rounded-lg hover:bg-opacity-80"
            >
              Zoom +
            </button>

            <button
              onClick={handleZoomOut}
              className="px-4 py-2 bg-black text-white rounded-lg hover:bg-opacity-80"
            >
              Zoom -
            </button>
          </div>

          <button
            onClick={onClose}
            className="text-white bg-red-500 hover:bg-red-600 p-2 rounded-full w-10 h-10"
          >
            ✕
          </button>
        </div>

        {/* BODY */}
        <div className="relative h-[calc(100vh-70px)] flex items-center justify-center">
          {isPdf && pdfLoading && (
            <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-60 z-10">
              <CircularProgress color="inherit" />
              <p className="text-white mt-3 text-sm">Loading PDF...</p>
            </div>
          )}

          {url?.match(/\.(jpg|jpeg|png|webp|gif|svg|jfif)$/i) && (
            <LazyLoadImage
              src={url}
              alt="Preview"
              effect="blur"
              className="max-w-full max-h-[90vh] object-contain rounded"
              style={{ transform: `scale(${zoom})` }}
            />
          )}
          

          {url?.match(/\.(heic)$/i) && (
            <HeicPreview
              url={url}
              alt={"heic"}
              style={{ transform: `scale(${zoom})` }}
              className="max-w-full max-h-[90vh] object-contain rounded"
            />
          )}

          {isPdf && (
            <iframe
              src={`https://docs.google.com/gview?url=${url}&embedded=true`}
              className="w-full h-full"
              title="PDF Preview"
              onLoad={() => setPdfLoading(false)}
            />
          )}

          {url?.match(/\.(mp4|mov|avi|wmv)$/i) && (
            <video controls className="max-w-full max-h-[90vh] rounded">
              <source src={url} />
            </video>
          )}
        </div>
      </Box>
    </Modal>
  );
};

export default Commonmodal;
